import * as React from "react";
import Image from "next/image";
import { shimmer, toBase64 } from "@src/utils/shimmer";
import Dialog from "src/components/Dialog";
import Link from "next/link";
import Button from "@src/components/Button";

import defaultImage from "../../../../public/images/image20.jpeg";
import bgImg from "../../../../public/images/t19bg.png";
import { GetAlbumDetailsQuery } from "@src/@types/api.d";

type Props = {
  eventId: number;
  albumDetailsData: GetAlbumDetailsQuery;
  eventSlug: string;
  sectionImage?: string;
};

export function insertAt(
  array: unknown[],
  index: number,
  ...elementsArray: unknown[]
) {
  array.splice(index, 0, ...elementsArray);
}

const Masonry: React.FC<Props> = ({
  eventId,
  eventSlug,
  albumDetailsData,
  sectionImage,
}) => {
  const mediaData = albumDetailsData?.getMedia || [];

  return !!albumDetailsData?.getMedia &&
    albumDetailsData?.getMedia?.length > 0 ? (
    <div className="w-full flex flex-col lg:flex-row lg:h-[100vh]">
      {/* Gallery Images Section - Use sectionImage for both mobile and desktop */}
      <div className="w-full h-[50vh] lg:flex-1 lg:h-full order-2 lg:order-1 lg:hidden">
        <div className="relative w-full h-full">
          {sectionImage ? (
            <Image
              placeholder="blur"
              blurDataURL={`data:image/svg+xml;base64,${toBase64(
                shimmer(700, 475)
              )}`}
              src={sectionImage}
              layout="fill"
              alt="gallery"
              className="object-cover object-center"
              sizes="(max-width: 1024px) 100vw, 50vw"
            />
          ) : (
            <div className="w-full h-full bg-gradient-to-br from-[#00234B] to-[#002D60]"></div>
          )}
        </div>
      </div>

      {/* Content Section - Title and button only */}
      <div className="w-full lg:flex-1 lg:h-full relative order-1 lg:order-2">
        {/* Background image */}
        <div className="absolute inset-0">
          <Image
            src={bgImg}
            alt="background"
            layout="fill"
            className="object-cover object-center"
          />
        </div>

        <div
          className="relative z-10 w-full h-full flex flex-col justify-center items-center py-12 lg:py-16 px-6 lg:px-10"
          style={{
            background: `
              url('/images/golden-quotes.png')
            `,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-ntFab text-[#FCE2B0] mb-8 lg:mb-12 text-center max-w-4xl leading-tight">
            Forever Never Looked Better!
          </h1>

          <Link
            href={`https://${eventSlug}.${process.env.NEXT_PUBLIC_INAWO_ALBUM_SITE_END}`}
            passHref
          >
            <a target="_blank">
              <button
                className="px-8 py-3 lg:px-10 lg:py-4 rounded-2xl transition duration-300 border border-[#FCE2B0] text-[#FCE2B0] text-lg lg:text-xl font-ebGaramond hover:bg-[#FCE2B0] hover:text-[#00234B] tracking-wider"
                type="button"
              >
                See Full Photobook
              </button>
            </a>
          </Link>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default Masonry;
